import React from 'react'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import CircularProgress from '../CircularProgress'

interface PerformanceScoreCardProps {
  score: number
  previousScore?: number
  level: string
  levelColor: string
  daysToNextReview?: number
  showTrend?: boolean
}

const PerformanceScoreCard = ({ 
  score, 
  previousScore, 
  level, 
  levelColor, 
  daysToNextReview,
  showTrend = true 
}: PerformanceScoreCardProps) => {
  const getTrendIcon = () => {
    if (!previousScore) return null
    
    const diff = score - previousScore
    if (diff > 0) return TrendingUp
    if (diff < 0) return TrendingDown
    return Minus
  }

  const getTrendColor = () => {
    if (!previousScore) return 'text-brand-gray'
    
    const diff = score - previousScore
    if (diff > 0) return 'text-success'
    if (diff < 0) return 'text-error'
    return 'text-brand-gray'
  }

  const TrendIcon = getTrendIcon()

  return (
    <div className="card-hover p-8 group text-center">
      {/* Score Display with Circular Progress */}
      <div className="relative mb-6">
        <CircularProgress percentage={score} size={120} />
        {showTrend && previousScore && TrendIcon && (
          <div className={`absolute -bottom-2 -right-2 p-2 rounded-full bg-brand-dark border-2 border-brand-dark-light ${getTrendColor()}`}>
            <TrendIcon size={16} />
          </div>
        )}
      </div>

      {/* Performance Level Badge */}
      <div className={`inline-flex px-4 py-2 rounded-full text-sm font-display font-semibold mb-4 ${levelColor}`}>
        {level}
      </div>

      {/* Score Details */}
      <div className="space-y-3">
        <div className="text-center">
          <div className="text-4xl font-display font-bold text-brand-primary mb-1 group-hover:scale-105 transition-transform duration-200">
            {score}
          </div>
          <div className="text-sm text-brand-gray font-display">
            Índice de Performance
          </div>
        </div>

        {/* Trend Comparison */}
        {showTrend && previousScore && (
          <div className={`flex items-center justify-center space-x-2 text-sm font-medium ${getTrendColor()}`}>
            {TrendIcon && <TrendIcon size={14} />}
            <span>
              {score > previousScore && '+'}
              {(score - previousScore).toFixed(1)} pts vs. período anterior
            </span>
          </div>
        )}

        {/* Next Review */}
        {daysToNextReview && (
          <div className="text-xs text-brand-gray bg-brand-dark-lighter p-2 rounded-monumenta">
            Próxima avaliação em {daysToNextReview} dias
          </div>
        )}
      </div>
    </div>
  )
}

export default PerformanceScoreCard
